function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import { HiOutlineDotsVertical } from "react-icons/hi";
import Modal from "react-bootstrap/Modal";
import * as Yup from "yup";
import "./Teams.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Dropdown from "react-bootstrap/Dropdown";
import { Field, Form, Formik } from "formik";
import ControlLabel from "react-bootstrap/FormLabel";
import FormControl from "react-bootstrap/FormControl";
import FormGroup from "react-bootstrap/FormGroup";
import { UserContext, FilterContext, SearchContext } from "../index";
import { TEAM_DETAILS_QUERY, CREATE_TEAM_MUTATION, EDIT_TEAM_NAME_MUTATION, DELETE_TEAM_MUTATION, TEAM_DELETE_USER_LIST_QUERY } from "./query";
import { useQuery, useMutation, useLazyQuery } from "@apollo/client";
import { ORGANISATION_TEAMS_QUERY } from "../Employees/query";
import Loader from "./../Loader/Loader";
import { toast } from "react-toastify";
import { findDemoOrLiveSite } from "../SideMenu/Header";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { isRateLimited, rateLimitMessage } from "../utils";
var TeamsSchema = Yup.object().shape({
  teamName: Yup.string().trim().required("Required").matches(/^[0-9a-zA-Z\s-&.(),]*$/, "We support alphanumeric and (.,-&) symbols only").max(30, "Maximum limit is 30 characters")
});
var Teams = function Teams(props) {
  var _teamWithSearch;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    teamModalShow = _useState2[0],
    setShow = _useState2[1];
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    showDeleteModal = _React$useState2[0],
    setShowDeleteModal = _React$useState2[1];
  //const [filterTeams, setFilterTeams] = useState(""); // SEARCH SETTINGS

  var _React$useContext = React.useContext(UserContext),
    user = _React$useContext.user;
  var _React$useContext2 = React.useContext(FilterContext),
    organisationId = _React$useContext2.organisationId,
    setTeamId = _React$useContext2.setTeamId,
    teamName = _React$useContext2.teamName,
    role = _React$useContext2.role,
    organisationBilling = _React$useContext2.organisationBilling,
    from = _React$useContext2.from,
    organisationSettings = _React$useContext2.organisationSettings,
    organisationStatus = _React$useContext2.organisationStatus;
  var _React$useContext3 = React.useContext(SearchContext),
    filterTeams = _React$useContext3.search;

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);
  React.useEffect(function () {
    if (from == "web" && role == "Member") {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [role]);
  React.useEffect(function () {
    if ((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);

  //console.log("organisationBilling", organisationBilling);

  var loadPage = role === "Admin" || role === null;
  var Redirect = props.redirect;

  //const organisationId = user?.organisations?.[0]?.id;
  var userId = user === null || user === void 0 ? void 0 : user.userId;
  var _useQuery = useQuery(TEAM_DETAILS_QUERY, {
      variables: {
        organisationId: organisationId
      },
      skip: !loadPage
    }),
    manageTeamsData = _useQuery.data,
    manageTeamsError = _useQuery.error,
    manageTeamsLoading = _useQuery.loading,
    teamRefetch = _useQuery.refetch;
  React.useEffect(function () {
    teamRefetch === null || teamRefetch === void 0 ? void 0 : teamRefetch();
  }, [props.location.key]);
  if (!loadPage) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/"
    });
  }
  if (manageTeamsLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (manageTeamsError) {
    return /*#__PURE__*/React.createElement("div", {
      className: "common-err-refresh-text"
    }, "Something went wrong, please refresh the page.");
  }
  if (!manageTeamsData) {
    return null;
  }
  var teamWithSearch = function teamWithSearch(teamDetails) {
    if (!filterTeams) {
      return teamDetails;
    }
    return teamDetails.filter(function (filterTeamData) {
      var _filterTeamData$teamN;
      return filterTeamData === null || filterTeamData === void 0 ? void 0 : (_filterTeamData$teamN = filterTeamData.teamName) === null || _filterTeamData$teamN === void 0 ? void 0 : _filterTeamData$teamN.toLowerCase().includes(filterTeams.toLowerCase());
    });
  };
  var handleClose = function handleClose() {
    setShow(false);
    setShow(null);
  };
  var handleShow = function handleShow(modalType, teamName, teamId) {
    var temp = {
      modalType: modalType,
      teamName: teamName,
      teamId: teamId,
      organisationId: organisationId,
      userId: userId
    };
    setShow(temp);
  };
  var handleDeleteClose = function handleDeleteClose() {
    setShowDeleteModal(null);
  };
  var handleDeleteShow = function handleDeleteShow(teamName, teamId, totalUsers, teamDeleteStatus, teamDeleteUser) {
    var temp = {
      teamName: teamName,
      teamId: teamId,
      organisationId: organisationId,
      userId: userId,
      totalUsers: totalUsers,
      teamDeleteStatus: teamDeleteStatus,
      teamDeleteUser: teamDeleteUser
    };
    setShowDeleteModal(temp);
  };
  var isDemoOrLiveSite = findDemoOrLiveSite();
  var isMobileView = window.innerWidth < 768;
  return /*#__PURE__*/React.createElement("div", {
    className: "manage-teams-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "Teams-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "Teams-root-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "Teams-root-header-left-side"
  }, isDemoOrLiveSite === "demo" ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-demo-site"
    }, "You can't add team in demo site.")
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "Teams-root-header-left-side-button disable-button"
  }, "Create New Team")) : organisationBilling.teamCount === 0 || manageTeamsData.teamDetails.length < organisationBilling.teamCount ? /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "Teams-root-header-left-side-button",
    onClick: function onClick() {
      return handleShow("createTeam", null, null);
    }
  }, "Create New Team") : /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to create a new team")
  }, /*#__PURE__*/React.createElement("div", {
    className: "Teams-root-header-left-side-button upgrade-plan-button-color"
  }, "Create New Team")))), /*#__PURE__*/React.createElement("div", {
    className: "Teams-root-content"
  }, manageTeamsData.teamDetails.length ? /*#__PURE__*/React.createElement(React.Fragment, null, isMobileView ? /*#__PURE__*/React.createElement(MobileViewTable, {
    isDemoOrLiveSite: isDemoOrLiveSite,
    teamWithSearch: teamWithSearch,
    manageTeamsData: manageTeamsData,
    setTeamId: setTeamId,
    organisationId: organisationId,
    handleShow: handleShow,
    handleDeleteShow: handleDeleteShow,
    history: props === null || props === void 0 ? void 0 : props.history
  }) : /*#__PURE__*/React.createElement(Table, {
    borderless: true,
    responsive: "sm",
    className: "Teams-root-content-table"
  }, /*#__PURE__*/React.createElement("thead", {
    className: "Teams-root-content-data-header"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Team Name"), /*#__PURE__*/React.createElement("th", null, "Employees"), /*#__PURE__*/React.createElement("th", null, "Team Head"), /*#__PURE__*/React.createElement("th", null))), /*#__PURE__*/React.createElement("tbody", {
    className: "Teams-root-table-body"
  }, teamWithSearch(manageTeamsData.teamDetails).map(function (team, key) {
    var teamIcon = team.teamName.split(/\s+/).map(function (s) {
      return s.charAt(0);
    }).join("").substring(0, 2);
    var teamHeadName = team.teamHeadName.toString();
    return /*#__PURE__*/React.createElement("tr", {
      className: "Teams-root-content-data-details",
      key: key,
      onClick: function onClick() {
        // setTeamId(team.teamId);
        // props?.history.push("/settings/manage-employees");
      }
    }, /*#__PURE__*/React.createElement("td", {
      className: "Teams-root-content-data-details-avatar",
      onClick: function onClick() {
        setTeamId(team.teamId);
        props === null || props === void 0 ? void 0 : props.history.push("/settings/manage-employees");
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "Teams-root-content-data-details-avatar-circle"
    }, teamIcon), /*#__PURE__*/React.createElement("p", {
      className: "Teams-root-content-data-details-name-data-team-name"
    }, team.teamName)), /*#__PURE__*/React.createElement("td", {
      onClick: function onClick() {
        setTeamId(team.teamId);
        props === null || props === void 0 ? void 0 : props.history.push("/settings/manage-employees");
      }
    }, team.totalUsers, " Employees"), /*#__PURE__*/React.createElement("td", {
      className: "Teams-root-content-data-details-name-data-team-name-width-td",
      onClick: function onClick() {
        setTeamId(team.teamId);
        props === null || props === void 0 ? void 0 : props.history.push("/settings/manage-employees");
      }
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, teamHeadName ? teamHeadName : "No team head assigned!")
    }, /*#__PURE__*/React.createElement("div", {
      className: "Teams-root-content-data-details-name-data-team-name-width"
    }, teamHeadName ? teamHeadName : "No team head assigned!"))), /*#__PURE__*/React.createElement("td", null, isDemoOrLiveSite !== "demo" ? /*#__PURE__*/React.createElement(EditMenuIcon, {
      organisationId: organisationId,
      teamName: team.teamName,
      teamId: team.teamId,
      handleShow: handleShow,
      handleDeleteShow: handleDeleteShow,
      teamLength: manageTeamsData === null || manageTeamsData === void 0 ? void 0 : manageTeamsData.teamDetails.length,
      totalUsers: team === null || team === void 0 ? void 0 : team.totalUsers,
      teamDeleteStatus: team === null || team === void 0 ? void 0 : team.teamDeleteStatus,
      teamDeleteUser: team === null || team === void 0 ? void 0 : team.teamDeleteUser
    }) : null));
  }), !((_teamWithSearch = teamWithSearch(manageTeamsData.teamDetails)) !== null && _teamWithSearch !== void 0 && _teamWithSearch.length) ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: 8,
    className: "text-muted text-center"
  }, "No team found for \"".concat(filterTeams, "\"\n                    "))) : null))) : /*#__PURE__*/React.createElement("div", {
    className: "no-data"
  }, "yet to create new team"))), /*#__PURE__*/React.createElement(TeamModal, {
    teamModalShow: teamModalShow,
    handleClose: handleClose
  }), /*#__PURE__*/React.createElement(DeleteTeamModal, {
    showDeleteModal: showDeleteModal,
    handleDeleteClose: handleDeleteClose
  }));
};
var MobileViewTable = function MobileViewTable(props) {
  var _teamWithSearch2;
  var isDemoOrLiveSite = props.isDemoOrLiveSite,
    teamWithSearch = props.teamWithSearch,
    manageTeamsData = props.manageTeamsData,
    setTeamId = props.setTeamId,
    filterTeams = props.filterTeams,
    organisationId = props.organisationId,
    handleShow = props.handleShow,
    handleDeleteShow = props.handleDeleteShow,
    history = props.history;
  return /*#__PURE__*/React.createElement(Table, {
    borderless: true,
    responsive: "sm",
    className: "Teams-root-content-table"
  }, /*#__PURE__*/React.createElement("thead", {
    className: "Teams-root-content-data-header"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Team Name"), /*#__PURE__*/React.createElement("th", null))), /*#__PURE__*/React.createElement("tbody", {
    className: "Teams-root-table-body"
  }, teamWithSearch(manageTeamsData.teamDetails).map(function (team, key) {
    var teamIcon = team.teamName.split(/\s+/).map(function (s) {
      return s.charAt(0);
    }).join("").substring(0, 2);
    var teamHeadName = team.teamHeadName.toString();
    return /*#__PURE__*/React.createElement("tr", {
      className: "Teams-root-content-data-details",
      key: key,
      onClick: function onClick() {}
    }, /*#__PURE__*/React.createElement("td", {
      className: "Teams-root-content-data-details-avatar",
      onClick: function onClick() {
        setTeamId(team.teamId);
        history.push("/settings/manage-employees");
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "Teams-root-content-data-details-avatar-circle"
    }, teamIcon), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
      className: "Teams-root-content-data-details-name-data-team-name"
    }, team.teamName), /*#__PURE__*/React.createElement("p", {
      className: "Teams-root-content-data-details-whole-div-employee-count"
    }, team.totalUsers, " Employees"))), /*#__PURE__*/React.createElement("td", null, isDemoOrLiveSite !== "demo" ? /*#__PURE__*/React.createElement(EditMenuIcon, {
      organisationId: organisationId,
      teamName: team.teamName,
      teamId: team.teamId,
      handleShow: handleShow,
      handleDeleteShow: handleDeleteShow,
      teamLength: manageTeamsData === null || manageTeamsData === void 0 ? void 0 : manageTeamsData.teamDetails.length,
      totalUsers: team === null || team === void 0 ? void 0 : team.totalUsers,
      teamDeleteStatus: team === null || team === void 0 ? void 0 : team.teamDeleteStatus,
      teamDeleteUser: team === null || team === void 0 ? void 0 : team.teamDeleteUser
    }) : null));
  }), !((_teamWithSearch2 = teamWithSearch(manageTeamsData.teamDetails)) !== null && _teamWithSearch2 !== void 0 && _teamWithSearch2.length) ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: 8,
    className: "text-muted text-center"
  }, "No team found for \"".concat(filterTeams, "\"\n                    "))) : null));
};
var EditMenuIcon = function EditMenuIcon(props) {
  var teamName = props.teamName,
    teamId = props.teamId,
    handleShow = props.handleShow,
    handleDeleteShow = props.handleDeleteShow,
    teamLength = props.teamLength,
    totalUsers = props.totalUsers,
    teamDeleteStatus = props.teamDeleteStatus,
    teamDeleteUser = props.teamDeleteUser;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dropdown, {
    className: "manage-teams-edit-menus"
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    variant: "success",
    id: "dropdown-basic"
  }, /*#__PURE__*/React.createElement(HiOutlineDotsVertical, {
    className: "manage-teams-edit-menus-icon"
  })), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, {
    onClick: function onClick() {
      return handleShow("editTeam", teamName, teamId);
    }
  }, "Edit"), teamLength > 1 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dropdown.Divider, null), /*#__PURE__*/React.createElement(Dropdown.Item, {
    className: "manage-teams-edit-menus-delete-icon",
    onClick: function onClick() {
      return handleDeleteShow(teamName, teamId, totalUsers, teamDeleteStatus, teamDeleteUser);
    }
  }, "Delete Team")) : null)));
};
var TeamModal = function TeamModal(props) {
  var teamModalShow = props.teamModalShow,
    handleClose = props.handleClose;
  if (teamModalShow == null) {
    return null;
  }
  var _useMutation = useMutation(CREATE_TEAM_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    createTeam = _useMutation2[0],
    createTeamLoading = _useMutation2[1].loading;

  // Server-side rejection, shown under the Create Team button.
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    teamSubmitError = _React$useState4[0],
    setTeamSubmitError = _React$useState4[1];
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(values, actions) {
      var teamName, variables, response, _response$errors, _response$errors$, _error$graphQLErrors, _error$graphQLErrors$;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            teamName = values.teamName;
            setTeamSubmitError(null);
            variables = {
              teamName: teamName,
              userId: teamModalShow.userId,
              organisationId: teamModalShow.organisationId
            };
            _context.prev = 3;
            _context.next = 6;
            return createTeam({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: TEAM_DETAILS_QUERY,
                variables: {
                  organisationId: teamModalShow.organisationId
                }
              }, {
                query: ORGANISATION_TEAMS_QUERY,
                variables: {
                  from: "web",
                  organisationId: teamModalShow.organisationId
                }
              }]
            });
          case 6:
            response = _context.sent;
            if (!response || !response.data || response.data.createTeam == null) {
              setTeamSubmitError((response === null || response === void 0 ? void 0 : (_response$errors = response.errors) === null || _response$errors === void 0 ? void 0 : (_response$errors$ = _response$errors[0]) === null || _response$errors$ === void 0 ? void 0 : _response$errors$.message) || "Error Occurred, Try again later!!!");
            } else {
              // setTeamActive
              handleClose();
              localStorage.setItem("token", response.data.createTeam);
              toast.success("Team added successfully!");
            }
            _context.next = 13;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](3);
            if (_context.t0.message.includes("already exist")) {
              actions.setFieldError("teamName", "Team already Exists");
            } else {
              // Show the server's own message (e.g. "max team limit exceed") under
              // the button. Anything else was silently swallowed here.
              setTeamSubmitError((_context.t0 === null || _context.t0 === void 0 ? void 0 : (_error$graphQLErrors = _context.t0.graphQLErrors) === null || _error$graphQLErrors === void 0 ? void 0 : (_error$graphQLErrors$ = _error$graphQLErrors[0]) === null || _error$graphQLErrors$ === void 0 ? void 0 : _error$graphQLErrors$.message) || "Error Occurred, Try again later!!!");
            }
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 10]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), [createTeam, createTeamLoading]);
  var _useMutation3 = useMutation(EDIT_TEAM_NAME_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    editTeamName = _useMutation4[0],
    editTeamNameLoading = _useMutation4[1].loading;
  var handleEditSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(values) {
      var teamName, variables, response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            teamName = values.teamName;
            variables = {
              teamName: teamName,
              teamId: teamModalShow.teamId,
              organisationId: teamModalShow.organisationId
            };
            _context2.prev = 2;
            _context2.next = 5;
            return editTeamName({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: TEAM_DETAILS_QUERY,
                variables: {
                  organisationId: teamModalShow.organisationId
                }
              }]
            });
          case 5:
            response = _context2.sent;
            if (!(!response || !response.data || response.data.editTeamName == null)) {
              _context2.next = 10;
              break;
            }
            throw new Error("error");
          case 10:
            // setTeamActive
            handleClose();
            toast.success("Team updated successfully!");
          case 12:
            _context2.next = 18;
            break;
          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](2);
            console.log(_context2.t0);
            if (isRateLimited(_context2.t0)) {
              toast.error(rateLimitMessage(_context2.t0));
            }
          case 18:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 14]]);
    }));
    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }(), [editTeamName, editTeamNameLoading]);
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleClose,
    centered: true
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "manage-team-modal-title"
  }, teamModalShow.modalType === "createTeam" ? "Create New Team" : "Edit Team")), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      teamName: teamModalShow.modalType === "editTeam" ? teamModalShow.teamName : ""
    },
    validationSchema: TeamsSchema,
    onSubmit: teamModalShow.modalType === "editTeam" ? handleEditSubmit : handleSubmit
  }, function (_ref3) {
    var setFieldValue = _ref3.setFieldValue;
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Field, {
      name: "teamName"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "manage-teams-edit-task-label-name"
      }, "Team Name"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error manage-teams-edit-task-label-name-error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        name: "name",
        type: "text",
        placeholder: "Enter the name",
        className: "manage-teams-edit-task-label-input"
      }, field)));
    }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: "manage-team-modal-button float-right"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary"
      // onClick={handleClose}
      ,
      className: "manage-team-modal-save-button",
      type: "submit"
    }, createTeamLoading ? "Loading..." : teamModalShow.modalType === "editTeam" ? "Update Team" : "Create Team")))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, teamSubmitError ? /*#__PURE__*/React.createElement("div", {
      className: "manage-team-modal-submit-error"
    }, teamSubmitError) : null)))));
  })));
};
var DeleteTeamModal = function DeleteTeamModal(props) {
  var _teamDeleteUserListDa, _teamDeleteUserListDa2, _teamDeleteUserListDa3, _teamDeleteUserListDa4;
  var showDeleteModal = props.showDeleteModal,
    handleDeleteClose = props.handleDeleteClose;
  if (showDeleteModal === null) {
    return null;
  }
  var teamId = showDeleteModal.teamId,
    organisationId = showDeleteModal.organisationId;
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    showErrModal = _React$useState6[0],
    setShowErrModal = _React$useState6[1];
  var _useLazyQuery = useLazyQuery(TEAM_DELETE_USER_LIST_QUERY, {
      variables: {
        teamId: teamId,
        organisationId: organisationId
      },
      fetchPolicy: "network-only",
      skip: !teamId && !organisationId
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getTeamDeleteUserListDetails = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    teamDeleteUserListData = _useLazyQuery2$.data,
    teamDeleteUserListError = _useLazyQuery2$.error,
    teamDeleteUserListLoading = _useLazyQuery2$.loading;
  React.useEffect(function () {
    if (showDeleteModal.teamId != null) {
      getTeamDeleteUserListDetails();
    }
  }, [showDeleteModal]);
  React.useEffect(function () {
    if (showErrModal == true) {
      getTeamDeleteUserListDetails();
    }
  }, [showErrModal]);
  var _useMutation5 = useMutation(DELETE_TEAM_MUTATION),
    _useMutation6 = _slicedToArray(_useMutation5, 2),
    deleteTeam = _useMutation6[0],
    deleteTeamLoading = _useMutation6[1].loading;
  var handleDeleteTeam = React.useCallback(function () {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var variables, response;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!deleteTeamLoading) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return");
          case 2:
            variables = {
              teamId: showDeleteModal.teamId,
              organisationId: showDeleteModal.organisationId
            };
            _context3.prev = 3;
            _context3.next = 6;
            return deleteTeam({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: TEAM_DETAILS_QUERY,
                variables: {
                  organisationId: showDeleteModal.organisationId,
                  teamId: showDeleteModal.teamId
                }
              }, {
                query: ORGANISATION_TEAMS_QUERY,
                variables: {
                  organisationId: showDeleteModal.organisationId
                }
              }]
            });
          case 6:
            response = _context3.sent;
            if (!(!response || !response.data || response.data.deleteTeam === null)) {
              _context3.next = 11;
              break;
            }
            throw new Error("error");
          case 11:
            handleDeleteClose();
            toast.success("Team deleted successfully!");
            setShowErrModal(false);
          case 14:
            _context3.next = 20;
            break;
          case 16:
            _context3.prev = 16;
            _context3.t0 = _context3["catch"](3);
            if (_context3.t0.message == "Some of your employees are assigned") {
              console.log("if");
              setShowErrModal(true);
            }
            toast.error("Error Occured, Try again later!");
          case 20:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[3, 16]]);
    }));
  }, [deleteTeam, deleteTeamLoading]);
  return /*#__PURE__*/React.createElement(Modal, {
    show: showDeleteModal,
    onHide: handleDeleteClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, "Deactivate Team")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, teamDeleteUserListLoading ? /*#__PURE__*/React.createElement(Loader, null) : teamDeleteUserListError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : teamDeleteUserListData && teamDeleteUserListData !== null && teamDeleteUserListData !== void 0 && teamDeleteUserListData.teamDeleteUserList ? teamDeleteUserListData && teamDeleteUserListData !== null && teamDeleteUserListData !== void 0 && (_teamDeleteUserListDa = teamDeleteUserListData.teamDeleteUserList) !== null && _teamDeleteUserListDa !== void 0 && _teamDeleteUserListDa.teamDeleteStatus ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "delete-team-user-already-exist-text"
  }, "Some of your employees are assigned to this team and they don't have access in any other team."), " ", /*#__PURE__*/React.createElement("div", {
    className: "delete-team-user-already-exist-secondary-text"
  }, "So, kindly move them to any other teams before deleting this", " ", /*#__PURE__*/React.createElement("span", {
    className: "manage-teams-edit-menus-delete-icon-name"
  }, showDeleteModal.teamName, ".")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "delete-team-user-already-exist-name-listing-text"
  }, "Reassign the team to the below members:"), /*#__PURE__*/React.createElement("div", {
    className: "delete-team-user-already-exist-name-listing-secondary-text"
  }, teamDeleteUserListData === null || teamDeleteUserListData === void 0 ? void 0 : (_teamDeleteUserListDa2 = teamDeleteUserListData.teamDeleteUserList) === null || _teamDeleteUserListDa2 === void 0 ? void 0 : (_teamDeleteUserListDa3 = _teamDeleteUserListDa2.teamDeleteUser) === null || _teamDeleteUserListDa3 === void 0 ? void 0 : _teamDeleteUserListDa3.map(function (user, key) {
    return /*#__PURE__*/React.createElement("div", null, "".concat(Number(key) + 1) + ")  " + "\n                      ".concat(user === null || user === void 0 ? void 0 : user.displayName) + "  (".concat(user === null || user === void 0 ? void 0 : user.emailId, ")"));
  })))) : /*#__PURE__*/React.createElement(React.Fragment, null, "Are you sure you want to delete", " ", /*#__PURE__*/React.createElement("span", {
    className: "manage-teams-edit-menus-delete-icon-name"
  }, showDeleteModal.teamName, "?"), " All data associated with this team will be permanently deleted. This action cannot be undone.") : null), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: handleDeleteClose
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "danger",
    className: "project-details-task-card-delete-button",
    onClick: handleDeleteTeam("inactive"),
    disabled: deleteTeamLoading || teamDeleteUserListLoading || teamDeleteUserListData !== null && teamDeleteUserListData !== void 0 && (_teamDeleteUserListDa4 = teamDeleteUserListData.teamDeleteUserList) !== null && _teamDeleteUserListDa4 !== void 0 && _teamDeleteUserListDa4.teamDeleteStatus || showDeleteModal.teamDeleteStatus ? true : false
  }, deleteTeamLoading ? "Loading..." : "Delete")));
};
export default Teams;